import React, { useCallback, useState, useMemo,useEffect } from 'react'
import styles from './ModuleSingleRecordRelatedModules.module.css'
import { useTranslation } from "react-i18next";
import CrmGrid from '../../../UI/Crm/CrmGrid/CrmGrid';
import ModuleRecords from './ModuleRecords';

const ModuleSingleRecordRelatedModules = ({
    moduleObj,
    relatedModules = [],
    recordId,
    onSelectConv,
    OnAddToDialListClicked
}) => {
    const [moduleGridStatus, setModuleGridStatus] = useState({})
    useEffect(()=>{
        setModuleGridStatus({})
    },[moduleObj?.name])
    // const [t] = useTranslation('crm')

    // let relatedModuleGridArr = []
    const relatedModuleGridArr = useMemo(() => {
        return relatedModules.map((relatedModule) => (
            <section
                key={relatedModule.name}
                className={styles['related-module-section']}
            >
                <ModuleRecords
                    moduleObj={relatedModule.moduleId}
                    multiSelectionEnable={true}
                    isGridMinimized={!moduleGridStatus[relatedModule.name]}
                    onMinimizeToggleClicked={() =>
                        setModuleGridStatus(s => ({
                            ...s,
                            [relatedModule.name]: !s[relatedModule.name]
                        }))
                    }
                    gridTitle={relatedModule.moduleId?.label}
                    isSubGrid={true}
                    gridCssClass={styles['records-grid']}
                    relatedToRecordId={recordId}
                    relatedModuleObj={moduleObj}
                    suppressLinkModules={false}
                    mode="unlink"
                    onSelectConv={onSelectConv}
                    OnAddToDialListClicked={OnAddToDialListClicked}
                    useLocalFilters={true}
                />
            </section>
        ));
    }, [relatedModules, moduleGridStatus, moduleObj, recordId]);

    return (
        <article className={`${styles['related-modules-container']}`}>
            {relatedModuleGridArr}
        </article>
    )

}

export default ModuleSingleRecordRelatedModules